<div *ngIf="!loader">
  <div class="img-wrapper" style="width: 265px; height: 370px">
    <div class="lable-block"></div>
    <div class="front">
      <a [routerLink]="['/shop/product/left/sidebar/', product.id]">
        <img [defaultImage]="
            ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'
          " [lazyLoad]="ImageSrc ? ImageSrc : product.imagemPrincipal" class="img-fluid lazy-loading"
          alt="{{ product.title }}" />
      </a>
    </div>

    <div class="cart-info cart-wrap">
      <a href="javascript:void(0)" title="Adicionar ao Carrinho" (click)="CartModal.openModal(product)"
        *ngIf="cartModal && product.situacao != 'Vitrine' && product.grade === 'Não'">
        <i class="ti-shopping-cart"></i>
      </a>
      <a href="javascript:void(0)" title="Adicionar ao Carrinho" (click)="addToCart(product)"
      *ngIf="!cartModal && product.situacao != 'Vitrine' && product.grade === 'Não'">
        <i class="ti-shopping-cart"></i>
      </a>
      <a href="javascript:void(0)" title="Adicioanr a Lista de Desejos" (click)="addToWishlist(product)">
        <i class="ti-heart" aria-hidden="true"></i>
      </a>
      <a *ngIf="product.grade === 'Não'" href="javascript:void(0)" title="Ver Produto" (click)="QuickView.openModal()">
        <i class="ti-search" aria-hidden="true"></i>
      </a>
      <a *ngIf="product.grade === 'Sim'" href="javascript:void(0)" title="Ver Produto" [routerLink]="['/shop/product/left/sidebar/', product.id]">
        <i class="ti-search" aria-hidden="true"></i>
      </a>
    </div>
  </div>
  <div class="product-detail">
    <div>
      <bar-rating [rate]="5" [readOnly]="true"></bar-rating>
      <a [routerLink]="['/shop/product/left/sidebar/', product?.id]">
        <h6>{{ product?.title | titlecase }}</h6>
      </a>
      <p>{{ product?.description }}</p>
      <h4 *ngIf="product?.precoOriginal >= 0">
        {{ product?.precoOriginal | dinheiro }}
        <del *ngIf="product?.discount"><span class="money">
            {{ product?.precoOriginal | dinheiro }}</span></del>
    </h4>
      <h4 *ngIf="product?.price <= 0">
        <span style="font-size: 17px">Preço sob consulta!</span>
      </h4>
      <ul class="color-variant" *ngIf="Color(product?.variants).length">
        <li [class]="color" *ngFor="let color of Color(product?.variants)" [ngStyle]="{ 'background-color': color }"
          (click)="ChangeVariants(color, product)"></li>
      </ul>
    </div>
  </div>
</div>
<app-skeleton-product-box *ngIf="loader"></app-skeleton-product-box>
<app-quick-view #quickView [product]="product" [currency]="currency"></app-quick-view>
<app-cart-modal #cartModal [product]="product" [currency]="currency" *ngIf="cartModal"></app-cart-modal>